import moment from 'moment'

/**
 * Format phone to (XXX)-XXX-XXX
 *
 * @param phone
 * @returns string
 */
const phoneFormat = (phone?: string | null): string => {
  if (phone === null) {
    return ''
  }

  if (phone.length === 7) {
    const firstThree = phone.substring(0, 3),
      lastFour = phone.substring(3)
    return [firstThree, lastFour].join('-')
  } else if (phone.length === 10) {
    const firstThree = phone.substring(0, 3),
      nextThree = phone.substring(3, 6),
      lastFour = phone.substring(6)
    return ['(' + firstThree + ')', nextThree, lastFour].join('-')
  } else {
    return phone
  }
}

/**
 * Format date to Month D, YYYY
 *
 * @param date
 * @returns string
 */
const dateFormat = (date: string | null): string => {
  const momentDate = moment(date, 'YYYY-MM-DD[T]HH:mm:ss', true)

  if (!date || !momentDate.isValid()) return ''

  return moment(date).format('LL')
}

export { phoneFormat, dateFormat }
